import React, { useContext, useEffect } from 'react'
import { SelectedUserContext } from "../../index";
import UserTypes1 from '../../../../../Classes/Models/Requests/Users/UserTypes';
import TherapistInfoCard from './TherapistInfoCard';
import EmployeeInfoCard from './EmployeeInfoCard';
import PatientInfoCard from './PatientInfoCard';
const index = ({GetUserData}) => {

    const User = useContext(SelectedUserContext)
    let UserTypes = new UserTypes1();

    const RouteToUserType = () =>{
        if(User.userType == UserTypes.Therapist 
        || User.userType == UserTypes.AssessmentTherapist){

            return(
                <TherapistInfoCard shadow={true}
                GetUserData = {GetUserData}
                User = {User}/>
            )
        }
        if(User.userType == UserTypes.AccountingEmployee
            || User.userType == UserTypes.AppointmentEmployee
            || User.userType == UserTypes.Admin){
                
                return(
                    <EmployeeInfoCard shadow={true}
                    GetUserData = {GetUserData}
                    User = {User}/>
                )
        }
        if(User.userType == UserTypes.Patient){
            return(
                <PatientInfoCard shadow={true}
                GetUserData = {GetUserData}
                User = {User}/>
            )
        }
    }
  return (
      <>
          {RouteToUserType()}
      </>
  )
}

export default index